import RouteConfig from './config/route';
import './App.scss';

import { log } from './utils/console.js';

function App() {
    return <RouteConfig />;
}

export default App;
